<template>
  <div class="chart">
    <div class="legend">
      <div v-for="(label, index) in labels" :key="index" class="property">
        <span class="tag" :style="{ background: chartColors[index] }"></span>
        <span class="label">{{ label }}</span>
      </div>
    </div>
    <doughnut-chart-instance
      :style="{ left: chartLeft }"
      :chart-data.sync="chartData"
      :options.sync="chartOptions"
      :height="height"
    />
  </div>
</template>

<script>
import DoughnutChartInstance from "./doughnut-chart";
import { sumOfElements } from "@/lib/utils";

export default {
  name: "DoughnutChart",

  props: {
    data: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: "#fff"
    },
    height: {
      type: Number,
      default: 300
    },
    fontSize: {
      type: Number,
      default: 16
    },
    chartColors: {
      type: Array,
      default: () => {
        return [
          "#5B0C1C",
          "#bd193a",
          "#e85472",
          "#ed7890",
          "#f4aebc",
          "#f9d2da",
          "#fbe4e9"
        ];
      }
    }
  },

  components: {
    DoughnutChartInstance
  },

  computed: {
    chartLeft() {
      return this.height >= 300 ? "120px" : "50px";
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Data One",
            backgroundColor: this.chartColors,
            borderColor: this.color,
            borderWidth: 1,
            data: this.data
          }
        ]
      };
    },

    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            color: this.color,
            align: "center",
            font: {
              size: this.fontSize
            },
            formatter: (value, context) => {
              const data = context.dataset && context.dataset.data;
              const total = sumOfElements(data);
              return Math.round((value / total) * 100) + "%";
            }
          }
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              return data.labels[tooltipItem.index];
            }
          }
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.chart {
  display: flex;
  align-items: center;
  position: relative;

  .legend {
    position: absolute;

    .property {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-bottom: 15px;
      }

      .tag {
        height: 10px;
        width: 10px;
        border-radius: 100px;
        background: green;
        margin-right: 7px;
      }

      .label {
        font-size: 0.75rem;
      }
    }
  }

  > div:not(.legend) {
    position: relative;
  }
}
</style>
